<template>
  <div>
    {{ $storeUm6p.Label.Annexes.VeuillezTelecharger }}
    <a target="_blank" :href="$storeUm6p.Formulaire.LienDocument">
      {{ $storeUm6p.Label.Annexes.CeDocument }}
    </a>
    {{ $storeUm6p.Label.Annexes.SignerDeposer }} : <br />
    <upload-btn
      class="mr-10"
      color="secondary"
      :loading="uploadFileLoading"
      :selectedFileName="
        this.$storeUm6p.Formulaire.PublipostageSigne.NomFichier
      "
      :defaultButtonText="$storeUm6p.Label.Annexes.SelectionnerDocument"
      ref="btnupload"
      :acceptFormats="['pdf']"
      @file-update="selectFile"
    >
    </upload-btn>
    <small>{{ $storeUm6p.Label.Annexes.FormatsAcceptesPdf }}</small>
    <br />
    <small>{{ $storeUm6p.Label.Annexes.TailleMaximale }}</small>

    <v-snackbar :timeout="2000" color="error" elevation="24" v-model="snackbar">
      {{ $storeUm6p.Label.Annexes.TailleMaximaleDepassee }}
    </v-snackbar>
  </div>
</template>
<script>
import UploadButton from "@/components/CustomFileUpload";
export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      $storeUm6p: this.$storeUm6p,
      $storeCatalogue: this.$storeCatalogue,
      uploadFileLoading: false,
      snackbar: false,
    };
  },
  methods: {
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size / 1024 > 8000) {
          this.$storeUm6p.Formulaire.PublipostageSigne.NomFichier = "";
          this.$storeUm6p.Formulaire.PublipostageSigne.DonneePieceJointe = null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.$storeUm6p.Formulaire.PublipostageSigne.NomFichier = file.name;
          await this.readFile(
            file,
            this.$storeUm6p.Formulaire.PublipostageSigne
          );
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.$storeUm6p.Formulaire.PublipostageSigne.NomFichier = "";
        this.$storeUm6p.Formulaire.PublipostageSigne.DonneePieceJointe = null;
      }
    },
    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        // Recupérer la chaine lise dans le data de l'élément en cours
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du ficheir
      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },
  },
};
</script>
